import React from 'react'
import {
  CompareWrapper,
  BaseImage,
  OverlayImage,
  SliderLabel,
  SliderInput,
  Divider,
  VisuallyHidden,
  Caption,
  Overlay,
  ArrowHandle,
} from './styles'

class ImageComparisonSlider extends React.Component {
  constructor(props) {
    super(props)

    this.wrapperRef = React.createRef()
    this.animationFrame = null

    this.state = {
      value: 50,
    }
  }

  componentWillUnmount() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
  }

  handleChange = event => {
    const numericValue = Number(event.target.value)
    const value = numericValue + '%'

    this.setState({
      value: numericValue,
    })

    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }

    this.animationFrame = requestAnimationFrame(() => {
      if (this.wrapperRef.current) {
        this.wrapperRef.current.style.setProperty('--exposure', value)
      }
    })
  }

  getHandleIcon = () => {
    const { value } = this.state

    if (value === 50) {
      return 'fas fa-arrows-alt-h'
    }

    if (value < 50) {
      return 'fas fa-arrow-right'
    }

    return 'fas fa-arrow-left'
  }

  getHandleLeft = () => {
    const { value } = this.state

    if (value <= 0) {
      return 'calc(var(--thumb-size) / 2)'
    }

    if (value >= 100) {
      return 'calc(100% - var(--thumb-size) / 2)'
    }

    return `${value}%`
  }

  render() {
    const {
      beforeSrc,
      afterSrc,
      beforeAlt,
      afterAlt,
      label,
      caption,
    } = this.props

    return (
      <div>
        <CompareWrapper ref={this.wrapperRef}>
          <BaseImage src={beforeSrc} alt={beforeAlt} />

          <Overlay>
            <OverlayImage src={afterSrc} alt={afterAlt} />
          </Overlay>

          <Divider aria-hidden="true" />

          <SliderLabel>
            <VisuallyHidden>{label || 'Compare the two images'}</VisuallyHidden>

            <SliderInput
              type="range"
              min="0"
              max="100"
              value={this.state.value}
              onChange={this.handleChange}
              aria-label={label || 'Compare the two images'}
            />
          </SliderLabel>

          <ArrowHandle
            aria-hidden="true"
            style={{ left: this.getHandleLeft() }}
          >
            <i className={this.getHandleIcon()} />
          </ArrowHandle>
        </CompareWrapper>

        {caption && <Caption>{caption}</Caption>}
      </div>
    )
  }
}

export default ImageComparisonSlider


// WEBPACK FOOTER //
// ./src/components/ImageComparisonSlider/index.js